import React from "react";
import { Card, Text, Checkbox } from "@merge-api/merge-javascript-shared";
import { LinkedAccountPurviewLabel } from "../../../../../../models/Entities";
import EmptyStateWrapper from "../../../../../shared/EmptyStateWrapper";

type Props = {
  purviewLabels?: LinkedAccountPurviewLabel[];
  // The noun used in the description, e.g. "Files" or "Emails".
  objectTypeText?: string;
};

const LinkedAccountSensitivityLabelsCard = ({ purviewLabels, objectTypeText = "Files" }: Props) => {
  if (!purviewLabels) return null;

  return (
    <Card className="mb-6">
      <div className="flex flex-col px-6 py-5 gap-y-1">
        <Text variant="h4">Excluded sensitivity labels</Text>
      </div>
      {purviewLabels.length > 0 ? (
        <div className="border-t border-gray-10">
          <div className="px-6 pt-5 pb-2">
            <Text>
              Your users can choose sensitivity labels to exclude from syncs. {objectTypeText} with
              the following labels will be excluded:
            </Text>
          </div>
          <table className="w-full table-auto">
            {purviewLabels.map((label, index) => {
              const labelText = label.parent_sensitivity_label_name
                ? `${label.parent_sensitivity_label_name} / ${label.sensitivity_label_name}`
                : label.sensitivity_label_name;
              return (
                <tr key={index}>
                  <td className="px-6 py-2">
                    <div className="flex flex-row items-center gap-x-3">
                      <Checkbox checked disabled />
                      <Text>{labelText}</Text>
                    </div>
                  </td>
                </tr>
              );
            })}
          </table>
          <div className="pb-5" />
        </div>
      ) : (
        <div className="border-t border-gray-10 pt-5 pb-6">
          <EmptyStateWrapper title="No sensitivity labels selected for this Linked Account" />
        </div>
      )}
    </Card>
  );
};

export default LinkedAccountSensitivityLabelsCard;
